/**
 * Eager product voiceover assets discovered for the default FrontDesk+ build.
 *
 * @since 1.0.0
 * @example
 * ```ts
 * Object.keys(importedAudioFiles).length;
 * ```
 */
export const importedAudioFiles = import.meta.glob<string>(
  "../assets/audio/*/*.mp3",
  {
    eager: true,
    import: "default",
    query: "?url",
  },
);
